import React, {useEffect, useState} from 'react';

import {Modal} from 'react-bootstrap';

import {ReactComponent as ImgLogo} from '../../../asset/img/micamall-logo-sign.svg';
import {ReactComponent as ImgLoader} from '../../../asset/img/icon/loader.svg';

import './Loader.scss';

const LoaderApp = props => {

    // -----------------------------------------------------------------------------------------------------------------

    const onShowHandler = () => {

        document.getElementById('modalLoader').style.paddingRight = document.querySelector('body').style.paddingRight

    }

    const [show, setShow] = useState(true)

    useEffect(() => {

        if (props.show) {

            // تاخیر جهت نمایش کوتاه ModalLoader
            let timeout = setTimeout(() => setShow(false), 500)

            return () => clearTimeout(timeout);

        }

    }, [props.show])

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <Modal id="modalLoader" show={show} fullscreen onShow={onShowHandler} backdrop={false} className="ltr bg-body" dialogClassName="rtl" contentClassName="bg-transparent">
            <Modal.Body className="d-flex flex-column justify-content-center align-items-center">
                <ImgLogo width={49} height={null} className="mb-4"/>
                <ImgLoader width={48} height={48}/>
            </Modal.Body>
        </Modal>
    )
}

export default LoaderApp;